import { Link } from 'react-router-dom';
import { getAccountStatusColor } from '@/types/customer';
import './CustomerTable.css';

interface CustomerTableProps {
  customers: any[];
  loading?: boolean;
}

export const CustomerTable = ({ customers, loading }: CustomerTableProps) => {
  if (loading) {
    return <div className="table-loading">Loading customers...</div>;
  }

  if (customers.length === 0) {
    return (
      <div className="table-empty">
        <p>No customers found</p>
        <p className="text-small text-secondary">Try adjusting your search or filters</p>
      </div>
    );
  }

  return (
    <div className="table-container">
      <table className="table customer-table">
        <thead>
          <tr>
            <th>Customer ID</th>
            <th>Name</th>
            <th>Phone</th>
            <th>Country</th>
            <th>Status</th>
            <th>Open Cases</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((customer: any) => (
            <tr key={customer.id}>
              <td className="customer-id">
                {customer.id.slice(0, 8)}
              </td>
              <td className="customer-name">
                <Link to={`/customers/${customer.id}`} className="customer-name-link">
                  {customer.first_name} {customer.last_name}
                </Link>
              </td>
              <td>{customer.phone_number}</td>
              <td>{customer.country || 'N/A'}</td>
              <td>
                <span className={`status-badge status-${getAccountStatusColor(customer.account_status)}`}>
                  {customer.account_status}
                </span>
              </td>
              <td className="customer-cases">
                {customer.open_cases?.[0]?.count > 0 ? (
                  <span className="case-badge case-badge-warning">
                    {customer.open_cases[0].count}
                  </span>
                ) : (
                  <span className="case-badge case-badge-none">0</span>
                )}
              </td>
              <td>
                <div className="customer-actions">
                  <Link
                    to={`/customers/${customer.id}`}
                    className="btn btn-ghost btn-small"
                  >
                    View
                  </Link>
                  <Link
                    to={`/cases/new?customer=${customer.id}`}
                    className="btn btn-secondary btn-small"
                  >
                    Create Case
                  </Link>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

